import React from 'react';
import PropTypes from 'prop-types';
import { Resource, DownloadLink } from '../../components';

const SecondaryResources = ({ assetsDownloadLink }) =>
  <div className="col-sm-12">
    <h2 className="resource-headline">Glyph and Product's Logos</h2>
    <p className="resource-subheadline">
      The Auth0 glyph is used whenever there are space constrains where the main logo would not fit,
      such as a small square or circle. Product logos such as Lock and Passwordless work best on
      dark backgrounds. Guardian and Webtask logos are designed for light backgrounds.
    </p>
    <div className="badge-product-grid">
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-glyph-109d4c73c4.svg" alt="Auth0 Glyph" />
      <Resource inverted src="https://cdn.auth0.com/website/assets/pages/press/img/resources/lock-logo-inverted-d92539b494.svg" alt="Lock Logo" />
      <Resource
        inverted
        src="https://cdn.auth0.com/website/assets/pages/press/img/resources/passwordless-logo-inverted-65f0d8f046.svg"
        alt="Passwordless Logo"
      />
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/guardian-logo-2253054088.svg" alt="Guardian Logo" />
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/webtask-logo-f479cae0f6.svg" alt="" />
    </div>
    <DownloadLink link={assetsDownloadLink} />
  </div>;

SecondaryResources.propTypes = {
  assetsDownloadLink: PropTypes.string.isRequired
};

export default SecondaryResources;



// WEBPACK FOOTER //
// ./src/pages/press/components/SecondaryResources/SecondaryResources.js